<template>
<div class="chapter">
<div class="inner_page">
<p class="noindentt"><em class="italic">I would like to thank those that supported and encouraged me. You all have been such a great team to work with and without your support this book would not have been possible. With gratitude and love. God bless each one of you!</em></p>
<p class="indent-top"><em class="italic">To my wife Carol</em></p>
<p class="indent"><em class="italic">To my children Matthew, Jody, Nicholas, Grace, Anne and Adam</em></p>
<p class="indent"><em class="italic">To my grandchildren Westin, Hudson, Graceyn, Jordan, Luke, Mackenna and Drew</em></p>
<p class="indent"><em class="italic">To my mother Mary Lou and my father and business partner Raymond Miller, Jr.</em></p>
<p class="indent"><em class="italic">To my friend Jeanne Hofmann</em></p>
<p class="indent"><em class="italic">To my nephew Danny Ciurczak</em></p>
<p class="indent"><em class="italic">To my business associate Paul Prizer</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm02.vue?54b2225a